import React, { useState, useEffect, useContext, useRef } from "react";
import TableStyle from "components/Content/Table/TableStyle.module.css";
import { styled, alpha } from '@mui/material/styles';
// import { AppContext } from "AppContext";
import TableAllData from "components/Content/CustomTable/TableAllData";
import { apiGet, apiPost } from "app/Services/ApiService";
import { apiUrls } from "common/ApiUrls";
import { Box, Button, Dialog, DialogActions, DialogContent, DialogTitle, Checkbox, Grid, FormControl, Input, Divider } from "@mui/material";
import LoadingButton from '@mui/lab/LoadingButton';
import ModalStyles from "components/Content/Modal/ModalStyles.module.css";
import ButtonStyle from "components/Button/ButtonStyle.module.css";

import EmployeeBenefitsMenu from "components/Menu/EmployeeBenefitsMenu";
import EmployeeProfile from "area/employer/EmployeeCensus/EmployeeProfile";
import moment from "moment";
import { Utils } from "common/Utils";
import * as Yup from 'yup';
import AximTooltip from "components/AximTooltip";

const CensusRehireEmployeeModal = ({ openRehireEmployeesModal, handleRehireEmployeesClose, termedEmployees, setTermedEmployees, employeesToRehire, setEmployeesToRehire,handleSaveRehireEmployee }) => {

  const formatSSN = (val) => "XXX-XX-" + val.replaceAll("-", "").slice(5);
  const [canRehire, setCanRehire] = React.useState(false);
  const toggleRehireEmployee = (insuredId, checked) => {
    console.log('toggleRehireEmployee')
    console.log(insuredId)
    console.log(checked)
    let ees = [...termedEmployees];
    console.log(ees, 'ees')
    let empIdx = ees.findIndex(e => e.insuredID == insuredId);
    ees[empIdx].toRehire = checked;
    ees[empIdx].Action = "Update";
    ees[empIdx].ChangeType = "Rehire";
    setTermedEmployees(ees);
    if (checked) {
      console.log([...employeesToRehire, ...ees.filter(e => e.insuredID == insuredId)])
      console.log('huh')
      console.log([...employeesToRehire, ...ees.filter(e => e.insuredID == insuredId)].filter(ee => ee.rehireDate == "" || moment(ee.rehireDate).year() < 1901))
      setCanRehire([...employeesToRehire, ...ees.filter(e => e.insuredID == insuredId)].filter(ee => ee.rehireDate == "" || moment(ee.rehireDate).year() < 1901).length == 0);
      setEmployeesToRehire([...employeesToRehire, ...ees.filter(e => e.insuredID == insuredId)])
    }
    else {
      console.log(employeesToRehire.filter(e => e.insuredID != insuredId))
      setCanRehire(employeesToRehire.filter(e => e.insuredID != insuredId).length > 0);
      setEmployeesToRehire(employeesToRehire.filter(e => e.insuredID != insuredId))
    }
  }
  const toggleRehireEmployeeDate = (insuredId, rehireDate) => {
    console.log('toggleRehireEmployeeDate')
    console.log(insuredId)
    console.log(rehireDate, 'rehireDate')
    let ees = [...termedEmployees];
    console.log(ees, 'ees')
    let empIdx = ees.findIndex(e => e.insuredID == insuredId);
    ees[empIdx].rehireDate = rehireDate;
    setTermedEmployees(ees);
    let empToHireIdx = employeesToRehire.findIndex(e => e.insuredID == insuredId);
    if (empToHireIdx >= 0) {
      let newEmployeesToRehire = [...employeesToRehire];
      newEmployeesToRehire[empToHireIdx].rehireDate = rehireDate;
      setEmployeesToRehire(newEmployeesToRehire);
      console.log('huh')
      console.log(newEmployeesToRehire.filter(ee => ee.rehireDate == "" || moment(ee.rehireDate).year() < 1901))
      setCanRehire(newEmployeesToRehire.filter(ee => ee.rehireDate == "" || moment(ee.rehireDate).year() < 1901).length == 0);
    }

  }

  const termEmployeeColumns = [
    {
      Header: "",
      accessor: "toRehire",
      Cell: ({ row }) => (
        <Box >
          <Checkbox
            checked={row.values.toRehire}
            onChange={e => toggleRehireEmployee(row.values.insuredID, e.target.checked)}
          ></Checkbox>
        </Box>
      )
    },
    {
      Header: "Rehire Date",
      accessor: "rehireDate",
      Cell: ({ row }) => (
        <Box >
          <FormControl
            className={ModalStyles.cField} >
            <Input id="my-input" aria-describedby="my-helper-text" type="date"
              defaultValue={
                (row.values.rehireDate === null)
                  ? ""
                  : Utils.convertToDatePicker(row.values.rehireDate)
              }
              onChange={e => toggleRehireEmployeeDate(row.values.insuredID, e.target.value)}
            />
          </FormControl>

        </Box>
      )
    },
    {
      Header: "InsuredID",
      accessor: "insuredID",
      style: {
        display: "none"
      },
      cellStyle: {
        display: "none"
      }
    },
    {
      Header: "benefitPackageID",
      accessor: "benefitPackageID",
      style: {
        display: "none"
      },
      cellStyle: {
        display: "none"
      }
    },
    {
      Header: "Last Name",
      accessor: "lastName",
    },
    {
      Header: "First Name",
      accessor: "firstName",
    },
    {
      Header: "Email",
      accessor: "email",
    },
    {
      Header: "SSN",
      accessor: "ssn",
      Cell: ({ row }) => (
        <Box >
          {formatSSN(row.values.ssn)}
        </Box>
      )
    },
    {
      Header: "DOB",
      accessor: "birthDateStr",
    },
    {
      Header: "Term Date",
      accessor: "termDateStr",
    }
  ];


  return (
    <>
      
      {/* Rehire Employees Modal */}
      <Dialog
        open={openRehireEmployeesModal}
        onClose={handleRehireEmployeesClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        className={ModalStyles.empDataModal}
        maxWidth="lg"
      >
        <DialogTitle id="alert-dialog-title">
          Rehire Employees
        </DialogTitle>
        <DialogContent className={ModalStyles.CustomTabsWrapper}>
          <TableAllData columns={termEmployeeColumns} data={termedEmployees} />
        </DialogContent>
        <DialogActions className={ButtonStyle.buttonWrapper}>
          <Button
            variant="outlined"
            onClick={handleSaveRehireEmployee}
            className={ButtonStyle.CsubmitBtn}
            disabled={!canRehire}
          >
            Save
          </Button>

          <Button
            variant="outlined"
            color="secondary"
            onClick={handleRehireEmployeesClose}
            className={ButtonStyle.CcancelBtn}
          >
            Close
          </Button>
        </DialogActions>
      </Dialog>
    </>
  )
};

export default CensusRehireEmployeeModal;